import { render, staticRenderFns } from "./PodrucjeTemeBase.vue?vue&type=template&id=7c39130f&scoped=true&"
import script from "./PodrucjeTemeBase.vue?vue&type=script&lang=js&"
export * from "./PodrucjeTemeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39130f",
  null
  
)

export default component.exports